import React from 'react';

const RequestsContext = React.createContext();

export default RequestsContext;
